import React, { useState } from "react";
import { createClient } from "@supabase/supabase-js";
import { Link } from "react-router-dom";
import "./Login.css";

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);

export default function Login() {
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (loading) return;

    setLoading(true);

    try {
      // 1. Login with Supabase Auth
      const { data, error } = await supabase.auth.signInWithPassword({
        email: form.email,
        password: form.password,
      });

      if (error) {
        setMessage(`Login failed: ${error.message}`);
        return;
      }

      const user = data?.user;

      if (!user) {
        setMessage("Login failed: user session not found.");
        return;
      }

      const userId = user.id;
      console.log("✅ Logged in user:", user);
      console.log("🔍 Fetching profile for user_id:", userId);
      console.log("✅ Logged in user id:", userId);
      console.log("✅ Logged in user email:", user.email);
      console.log(
        "🔍 get-profile URL:",
        `${process.env.REACT_APP_API_BASE_URL}/get-profile?user_id=${userId}`
      );

      // 2. Fetch profile from backend
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/get-profile?user_id=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let profileData = null;

      try {
        profileData = await res.json();
      } catch (jsonError) {
        console.error("❌ Failed to parse get-profile response as JSON:", jsonError);
        throw new Error("Failed to read user profile response.");
      }

      console.log("🔍 profileData:", profileData);

      if (!res.ok) {
        throw new Error(profileData?.detail || "Failed to fetch user role");
      }

      if (!profileData) {
        throw new Error("User profile not found.");
      }

      if (!profileData.role) {
        throw new Error("User profile exists but role is missing.");
      }

      const role = profileData.role;
      console.log("✅ User role:", role);

      // 3. Redirect based on role
      switch (role) {
        case "superadmin":
          window.location.href = "/admin";
          break;

        case "clinic_admin":
          window.location.href = "/dashboard";
          break;

        case "staff":
          window.location.href = "/staff";
          break;

        case "ai_assistant":
          window.location.href = "/dashboard";
          break;

        default:
          setMessage(`Unknown role: ${role}. Please contact support.`);
      }
    } catch (err) {
      console.error("❌ Login error:", err);
      setMessage(err.message || "Unexpected error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-header">
        <img src="/logo.png" alt="Olumis AI Logo" className="login-logo" />
        <p>
          Don’t have an account? <Link to="/start">Sign Up</Link>
        </p>
      </div>

      <div className="login-container">
        <div className="login-form-box">
          <h2>Sign in to Your Dashboard</h2>

          <form onSubmit={handleSubmit}>
            <label>Username/Email *</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />

            <label>Password *</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />

            <button type="submit" disabled={loading}>
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          {message && <p className="login-error">{message}</p>}

          <a href="/forgot-password" className="forgot-link">
            Forgot Username/Password?
          </a>
        </div>

        <div className="login-image-box">
          <img src="/infographic.png" alt="Olumis Value" />
        </div>
      </div>
    </div>
  );
}